import styles from "./styles.module.scss";
import cn from "classnames";

export const GlobalThreePhotos = ({ backgroundImage, photos, title, description, className }) => {
  return (
    <section className={cn(styles.GlobalThreePhotos, className)}>
      <div className={styles.bg} style={{ backgroundImage: `url(${backgroundImage?.url})` }}>
        <div className={styles.glow} />
        <div className={styles.container}>
          <div className={styles.photos}>
            {photos?.map((photo, idx) => (
              <div
                key={idx}
                className={styles.photo}
                style={{ width: `${photo.size}%` }}
                data-sourceflow-prop={`photos[${idx}]`}
              >
                <div
                  className={styles.photoImage}
                  style={{
                    backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.5) 100%), url(${photo?.image?.url})`,
                  }}
                  data-sourceflow-prop={`photos[${idx}].image`}
                />
                <div className={styles.label} data-sourceflow-prop={`photos[${idx}].label`}>
                  {photo?.label}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.textContent}>
            <h2 className={styles.title} data-sourceflow-prop="title">
              {title}
            </h2>
            <div
              className={styles.description}
              data-sourceflow-prop="description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalThreePhotos;
